import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import '../styles/Navigation.css';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navigation-header">
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="navigation-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_adapt-wellness/artifacts/oi00lf58_WhatsApp%20Image%202026-01-22%20at%2018.24.42.jpeg" 
              alt="Mushhrushh Logo" 
              className="logo-image"
            />
            <span className="logo-text">MUSHHRUSHH</span>
          </Link>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <ul className={`navigation-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li>
              <button onClick={() => scrollToSection('about')} className="navigation-link">
                About
              </button>
            </li>
            <li>
              <Link to="/history" className="navigation-link" onClick={() => setMobileMenuOpen(false)}>
                History
              </Link>
            </li>
            <li>
              <Link to="/how-to-consume" className="navigation-link" onClick={() => setMobileMenuOpen(false)}>
                How to Consume
              </Link>
            </li>
            <li>
              <Link to="/faq" className="navigation-link" onClick={() => setMobileMenuOpen(false)}>
                FAQ
              </Link>
            </li>
            <li>
              <button onClick={() => scrollToSection('contact')} className="navigation-link cta-link">
                Contact Us
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;